/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
import {
  ConnectionRequestResponse,
  CreateConnectionRequestResponse,
  GenericErrorResponse,
} from './responses';

import { ContentType, HttpClient, RequestParams } from './httpClient';
import { CreateConnectionRequestPayload, UpdateConnectionRequestPayload, UpdateIntegrationPayload } from './requests';

export class Integrations<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    getIntegrations = (teamId: string, params: RequestParams = {}) =>
      this.request<unknown, GenericErrorResponse>({
        path: `/teams/${teamId}/integrations`,
        method: 'GET',
        format: 'json',
        secure: true,
        ...params,
      });
    getAdapters = (teamId: string, params: RequestParams = {}) =>
      this.request<unknown, GenericErrorResponse>({
        path: `/teams/${teamId}/adapters`,
        method: 'GET',
        format: 'json',
        secure: true,
        ...params,
      });
    deleteIntegration = (connectionId: string, params: RequestParams = {}) =>
      this.request<unknown, GenericErrorResponse>({
        path: `/integrations/${connectionId}`,
        method: 'DELETE',
        format: 'json',
        secure: true,
        ...params,
      });
    createConnectionRequest = (teamId: string, data: CreateConnectionRequestPayload, params: RequestParams = {}) =>
      this.request<CreateConnectionRequestResponse, GenericErrorResponse>({
        path: `/teams/${teamId}/connection-requests`,
        method: 'POST',
        type: ContentType.Json,
        format: 'json',
        secure: true,
        body: data,
        ...params,
      });
      updateIntegration = (teamId: string, data: UpdateIntegrationPayload, params: RequestParams = {}) =>
      this.request<CreateConnectionRequestResponse, GenericErrorResponse>({
        path: `/teams/${teamId}/connection-requests`,
        method: 'POST',
        type: ContentType.Json,
        format: 'json',
        secure: true,
        body: data,
        ...params,
      });
    createConnectionAttempt = (connectionRequestId: string, params: RequestParams = {}) =>
      this.request<ConnectionRequestResponse, GenericErrorResponse>({
        path: `/connection-requests/${connectionRequestId}`,
        method: 'POST',
        type: ContentType.Json,
        format: 'json',
        secure: true,
        ...params,
      });
    updateConnectionAttempt = (connectionAttemptId: string, data: UpdateConnectionRequestPayload, params: RequestParams = {}) =>
      this.request<ConnectionRequestResponse, GenericErrorResponse>({
        path: `/connection-requests/progress/${connectionAttemptId}`,
        method: 'PATCH',
        type: ContentType.Json,
        format: 'json',
        secure: true,
        body: data,
        ...params,
      });
}
